import PropTypes from 'prop-types'
import React from 'react'
import { InformationIcon } from '../../assets/icons/InformationIcon'
import { getMergedClassNames } from '../../utils/HTMLutils'
import { TooltipProps } from '../tooltipManager/TooltipProps'
import './Information.scss'
const rootClassName = 'component-information-icon'

export default function Information(props) {
  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([rootClassName, props.className || ''])
    }
    delete p.icon
    delete p['tooltip-text']
    delete p['tooltip-position']
    return p
  }
  return (
    <div {...getProps()}>
      <div
        className={`${rootClassName}-icon`}
        tooltip-text={props['tooltip-text']}
        tooltip-position={props['tooltip-position']}
      >
        {props.icon}
      </div>
    </div>
  )
}

Information.propTypes = {
  'tooltip-position': TooltipProps['tooltip-position'],
  'tooltip-text': TooltipProps['tooltip-text'],
  icon: PropTypes.any
}
Information.defaultProps = {
  icon: <InformationIcon />
}
